var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isInstalled)?_c('div',{staticClass:"InstallButton"},[(_vm.installable)?_c('b-button',{attrs:{"size":"is-medium","icon-left":"download"},on:{"click":function($event){return _vm.install()}}},[_vm._v(_vm._s(_vm.$t('general.install_app')))]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }